export default __webpack_public_path__ + "static/media/engine.7539079c.svg";